\<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="설치지역"
            name="installLocation"
            v-model="searchParam.installLocation">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-process
            label="관련공정"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="관리부서"
            :isFirstValue="false"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="interlock"
          title="소화설비설치계획 목록"
          tableId="interlock"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="fireEquipmentId"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="등록" icon="add" @btnClicked="equipmentPopup" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fire-equipment',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'installLocation',
            field: 'installLocation',
            label: '설치지역',
            align: 'center',
            style: 'width:150px',
            type: 'link',
            sortable: true,
          },
          {
            name: 'fireExtinguisher',
            field: 'fireExtinguisher',
            label: '소화기',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'autoSpreadFire',
            field: 'autoSpreadFire',
            label: '자동확산소화기',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'autoFire',
            field: 'autoFire',
            label: '자동소화장치',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'standPipe',
            field: 'standPipe',
            label: '옥내소화전',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'sprinkler',
            field: 'sprinkler',
            label: '스프링쿨러',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'waterSpray',
            field: 'waterSpray',
            label: '물분부소화설비',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'poSpray',
            field: 'poSpray',
            label: '포소화설비',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'co2Spray',
            field: 'co2Spray',
            label: 'CO2소화설비',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'halogenSpray',
            field: 'halogenSpray',
            label: '할로겐화합물소화설비',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'cleanSpray',
            field: 'cleanSpray',
            label: '청정소화약제소화설비',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'outdoorPipe',
            field: 'outdoorPipe',
            label: '옥외소화전',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        installLocation: '',
        processCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.lbe.fireequip.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () => import(`${"./firefightingEquipmentInfoDetail.vue"}`);
      this.popupOptions.title = '소화설비설치계획 상세';
      this.popupOptions.param = {
        fireEquipmentId: result ? result.fireEquipmentId : '',
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
